import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  Activity,
  ActivityListResponse,
  PostNote,
} from "@breeze/shared";
import { fetchActivity, postNote } from "../api.js";

export function useActivity(
  cardId: number | null
): ReturnType<typeof useQuery<ActivityListResponse>> {
  return useQuery<ActivityListResponse>({
    queryKey: ["activity", cardId],
    queryFn: () => fetchActivity(cardId as number),
    enabled: cardId !== null,
  });
}

export function usePostNote(
  cardId: number | null
): ReturnType<
  typeof useMutation<{ activity: Activity }, Error, PostNote>
> {
  const qc = useQueryClient();
  return useMutation<{ activity: Activity }, Error, PostNote>({
    mutationFn: (body) => postNote(cardId as number, body),
    onSuccess: (data) => {
      if (cardId === null) return;
      qc.setQueryData<ActivityListResponse>(["activity", cardId], (prev) => {
        if (!prev) return { activity: [data.activity] };
        if (prev.activity.some((a) => a.activityId === data.activity.activityId)) return prev;
        return { activity: [data.activity, ...prev.activity] };
      });
    },
  });
}
